import Vue from "vue";
import VueI18n from "vue-i18n";
import enLocale from "element-ui/lib/locale/lang/en";
import viLocale from "element-ui/lib/locale/lang/vi";

Vue.use(VueI18n);

const messages = {
  /********** TIENG ANH */
  en: {
    done:"Done",
    personInfo:"Personal information",
    fullName:"Full name",
    phone: "Phone",
    gender:"Gender",
    birthday:"Birthday",
    address:"Address",
    sent:"Send",
    surveyInfo:"Survey information",
    pleaseChooseGender:"Please select a gender",
    requiredChoose:"Required to choose",
    ...enLocale
  },

  /********** TIENG VIET */
  vi: {
    done:"Hoàn thành",
    personInfo:"Thông tin cá nhân",
    fullName:"Họ tên",
    phone:"Số điện thoại",
    gender:"Giới tính",
    birthday:"Ngày sinh",
    address:"Địa chỉ",
    sent:"Gửi",
    surveyInfo:"Thông tin khảo sát",
    pleaseChooseGender:"Vui lòng chọn giới tính",
    requiredChoose:"Bắt buộc chọn",
    ...viLocale
  }
};

// Create VueI18n instance with options
export const i18n = new VueI18n({
  locale: (Vue.cookie ? Vue.cookie.get("language") : "vi") || "vi",
  fallbackLocale: "vi",
  silentTranslationWarn: true,
  messages // set locale messages
});
